import * as React from "react";
const SvgFiRrShieldAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.573 2.126 12.339.059A1.1 1.1 0 0 0 12 0c-.162 0-.307.047-.339.059L5.427 2.126A4.99 4.99 0 0 0 2 6.872v5.171c0 6.563 7.005 10.577 9.152 11.65l.402.201a1 1 0 0 0 .82.033l.418-.168c2.16-.869 9.207-4.281 9.207-11.717V6.871a4.99 4.99 0 0 0-3.427-4.746zM4 12.043V6.872c0-1.295.826-2.439 2.056-2.848L11 2.385v18.956c-2.483-1.426-7-4.659-7-9.298m16 0c0 5.353-4.565 8.267-7 9.44V2.385l4.944 1.639A3 3 0 0 1 20 6.872z"
    />
  </svg>
);
export default SvgFiRrShieldAlt;
